import TextFieldSkeleton from '../../../../../../components/FormControls/TextField/Skeleton';

export interface UnpublishedPollTitleSkeletonProps {
  className?: string;
}

const UnpublishedPollTitleSkeleton = ({ className }: UnpublishedPollTitleSkeletonProps) => {
  return <TextFieldSkeleton className={className} />;
};

export default UnpublishedPollTitleSkeleton;
